import { render, staticRenderFns } from "./TravelAround.vue?vue&type=template&id=f85c8546&scoped=true&"
import script from "./TravelAround.vue?vue&type=script&lang=js&"
export * from "./TravelAround.vue?vue&type=script&lang=js&"
import style0 from "./TravelAround.vue?vue&type=style&index=0&id=f85c8546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c8546",
  null
  
)

export default component.exports